import { render, staticRenderFns } from "./AccountAddresses.vue?vue&type=template&id=19b05b5b&"
import script from "./AccountAddresses.vue?vue&type=script&lang=js&"
export * from "./AccountAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports